module.exports = __webpack_public_path__ + "static/media/atv.5a01e40f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/atv.svg
// module id = 969
// module chunks = 0